/**
 * Canonical social handles. Product name is TrumpyBird, but handle availability
 * forced a split on X + Instagram. Never hardcode a handle elsewhere — always
 * import from this file so every scene / share card / footer / marketing surface
 * stays in sync when a handle changes or a platform is added.
 */
export interface Social {
  platform: string;
  handle: string;
  url: string;
}

export const SOCIALS: Readonly<Record<string, Social>> = {
  tiktok: {
    platform: 'TikTok',
    handle: '@trumpybird',
    url: 'https://tiktok.com/@trumpybird',
  },
  youtube: {
    platform: 'YouTube',
    handle: '@trumpybird',
    url: 'https://youtube.com/@trumpybird',
  },
  x: {
    platform: 'X',
    handle: '@birdtrumpy',
    url: 'https://x.com/birdtrumpy',
  },
  instagram: {
    platform: 'Instagram',
    handle: '@birdtrumpy',
    url: 'https://instagram.com/birdtrumpy',
  },
  twitch: {
    platform: 'Twitch',
    handle: 'trumpybird',
    url: 'https://twitch.tv/trumpybird',
  },
  kick: {
    platform: 'Kick',
    handle: 'trumpybird',
    url: 'https://kick.com/trumpybird',
  },
  telegram: {
    platform: 'Telegram',
    handle: '@TrumpyBirdBot',
    url: 'https://t.me/TrumpyBirdBot',
  },
};

export const FOLLOW_CTA =
  'Follow @trumpybird on TikTok & YouTube, @birdtrumpy on X & Instagram.';
